








































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { getAdminPermition, getRootPermition } from "@/services/accessDecoder";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";

import StandartModal from "@/components/app/standart-modal.vue";
import NavDropZone from "./nav20/nav-drop-zone.vue";
import NavPageEditModal from "./nav20/nav-page-edit-modal.vue";

import {
  PALETTE,
  applyDelete,
  applyMove,
  diffUpdates,
  folderChildrenList,
  getFolders,
  getHome,
  homeMainList,
  homeMinList,
  isFolder,
  normalizePage,
  paletteList,
  placementOf,
  sortedByOrder,
} from "@/services/nav-panel/nav-model";

const ALL_LOCALES = ["ru", "de", "en", "fr", "it", "zh", "tr", "es"];

interface IDragEvent {
  added?: { element: IPageConfig; newIndex: number };
  moved?: { element: IPageConfig; newIndex: number };
}

interface INavPageEditPayload {
  page: IPageConfig;
  patch: {
    name: Record<string, string>;
    grid: number;
    src: IPageConfig["src"];
    params?: IPageConfig["params"];
    show: boolean;
    active: boolean;
  };
}

@Component({
  name: "nav20-configuration",
  components: {
    StandartModal,
    NavDropZone,
    NavPageEditModal,
  },
})
class NavConfiguration20 extends Vue {
  @Prop({ type: Boolean, default: true }) showTitle!: boolean;

  pages: Array<IPageConfig> = [];
  loading = true;
  saving = false;
  editPage: IPageConfig | null = null;
  folderName = "";

  get canEdit(): boolean {
    return getRootPermition() || getAdminPermition();
  }

  get isRoot(): boolean {
    return getRootPermition();
  }

  get home(): IPageConfig | undefined {
    return getHome(this.pages);
  }

  get homeId(): string | undefined {
    return this.home ? this.home._id : undefined;
  }

  get folders(): Array<IPageConfig> {
    return sortedByOrder(getFolders(this.pages));
  }

  get folderIds(): Array<string> {
    return this.folders.map((folder) => folder._id);
  }

  get mainList(): Array<IPageConfig> {
    return homeMainList(this.pages, this.homeId);
  }

  get minList(): Array<IPageConfig> {
    return homeMinList(this.pages, this.homeId);
  }

  get palette(): Array<IPageConfig> {
    return paletteList(this.pages, this.homeId, this.folderIds);
  }

  get editPlacement(): string {
    if (!this.editPage) return "palette";
    const placement = placementOf(this.editPage, this.homeId, this.folderIds);
    return placement.kind === "folder" ? "grid" : placement.kind;
  }

  childrenOf(folderId: string): Array<IPageConfig> {
    return folderChildrenList(this.pages, folderId);
  }

  folderIcon(folder: IPageConfig): string {
    const icon = folder.src?.icon;
    if (icon && typeof icon === "object" && icon.icon) return icon.icon;
    return "folder2";
  }

  async loadPages(): Promise<void> {
    this.loading = true;
    try {
      const res = await this.$axios.get(configuration.pages.main);
      if (res.status === 200) {
        const list: Array<IPageConfig> = Array.isArray(res.data)
          ? res.data
          : [];
        const visible = getRootPermition()
          ? list
          : list.filter((el: IPageConfig) => el.show);
        this.pages = visible.map((el) => normalizePage(el));
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("configuration.nav20.error-load")),
        type: "warn",
      });
    } finally {
      this.loading = false;
    }
  }

  onChange(key: string, evt: IDragEvent): void {
    const added = evt.added || evt.moved;
    if (!added || !added.element) return;
    const before = this.pages;
    const after = applyMove(this.pages, added.element._id, key, added.newIndex);
    if (after === before) return;
    this.pages = after;
    this.persist(before, after);
  }

  removeFromPanel(item: IPageConfig): void {
    if (item.lock) return;
    const before = this.pages;
    const after = applyMove(this.pages, item._id, PALETTE, this.palette.length);
    if (after === before) return;
    this.pages = after;
    this.persist(before, after);
  }

  async persist(
    before: Array<IPageConfig>,
    after: Array<IPageConfig>
  ): Promise<void> {
    const updates = diffUpdates(before, after);
    if (!updates.length) return;
    this.saving = true;
    try {
      const res = await this.$axios.put(configuration.pages.main, updates);
      if (res.status === 200) {
        const updated: Array<IPageConfig> = Array.isArray(res.data)
          ? res.data
          : [];
        this.pages = this.pages.map((page) => {
          const fresh = updated.find((u) => u._id === page._id);
          return fresh ? normalizePage(fresh) : page;
        });
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("configuration.nav20.saved")),
        });
      } else {
        throw new Error("bulk update failed");
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      await this.loadPages();
    } finally {
      this.saving = false;
    }
  }

  openEdit(page: IPageConfig): void {
    this.editPage = page;
    this.$bvModal.show("nav20-page-edit");
  }

  async onSaveEdit(payload: INavPageEditPayload): Promise<void> {
    if (!payload.page) return;
    this.saving = true;
    try {
      const res = await this.$axios.put(
        `${configuration.pages.main}/${payload.page._id}`,
        payload.patch
      );
      if (res.status === 200) {
        this.pages = this.pages.map((page) =>
          page._id === res.data._id ? normalizePage(res.data) : page
        );
        this.$bvModal.hide("nav20-page-edit");
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      } else {
        throw new Error("save failed");
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.saving = false;
    }
  }

  async onDelete(page: IPageConfig): Promise<void> {
    const name = String(this.$getLocale(page.name));
    const message = isFolder(page)
      ? String(
          this.$i18n.t("configuration.nav20.delete-folder-confirm", {
            name,
          })
        )
      : String(this.$i18n.t("configuration.nav20.delete-confirm", { name }));
    const ok = await this.$bvModal.msgBoxConfirm(message, {
      title: String(this.$i18n.t("configuration.nav20.delete-title")),
      okVariant: "danger",
      okTitle: String(this.$i18n.t("buttons.delete")),
      cancelTitle: String(this.$i18n.t("buttons.cancel")),
    });
    if (!ok) return;

    this.saving = true;
    try {
      const before = this.pages;
      const after = applyDelete(this.pages, page._id);
      const updates = diffUpdates(before, after);
      if (updates.length) {
        const res = await this.$axios.put(configuration.pages.main, updates);
        if (res.status !== 200) throw new Error("bulk update failed");
      }
      const del = await this.$axios.delete(
        `${configuration.pages.main}/force/${page._id}`
      );
      if (del.status !== 200) throw new Error("delete failed");
      this.pages = after;
      this.$bvModal.hide("nav20-page-edit");
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      await this.loadPages();
    } finally {
      this.saving = false;
    }
  }

  async createFolder(): Promise<void> {
    const name = this.folderName.trim();
    if (!name) return;
    this.saving = true;
    try {
      const locales: Record<string, string> = {};
      for (const lang of ALL_LOCALES) locales[lang] = name;
      const body = {
        name: locales,
        footer: ["back", "exit", "tv"],
        show: true,
        active: false,
        lock: false,
        route: "StandartSubMenuPage",
        grid: 1,
        children: [],
        src: {
          background: "",
          image: "",
          icon: { icon: "folder2", lib: "material" },
        },
        informers: [],
        params: {
          tv: {
            footer: ["back", "exit", "tv"],
            route: "StandartSubMenuPage",
            variant: { grid: 1, class: "btn-dark-opacity-20" },
          },
          mobile: { route: "" },
        },
        navigation: { children: [], pageGroup: "", navigationGroup: "" },
      };
      const res = await this.$axios.post(configuration.pages.main, body);
      if (res.status === 200) {
        this.folderName = "";
        this.$bvModal.hide("nav20-create-folder");
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        await this.loadPages();
      } else {
        throw new Error("create failed");
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.saving = false;
    }
  }

  mounted(): void {
    this.loadPages();
  }
}
export default NavConfiguration20;
